import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center mt-4" }
const _hoisted_2 = {
  key: 0,
  class: "inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]",
  role: "status"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]" }, "Loading...", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 2,
  class: "border m-[5%] p-[5%]"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm mb-[3%]" }, "Se debe crear un nuevo testigo", -1)
const _hoisted_7 = {
  key: 3,
  class: "border m-[5%] p-[5%]"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm mb-[3%]" }, "Testigo encontrado", -1)
const _hoisted_9 = { class: "text-sm mb-[3%]" }
const _hoisted_10 = { class: "text-sm mb-[3%]" }
const _hoisted_11 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextField = _resolveComponent("TextField")!
  const _component_NewModal = _resolveComponent("NewModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_NewModal, {
      title: "Creación de contrato",
      visible: _ctx.visible,
      "onUpdate:visible": _cache[3] || (_cache[3] = (e) => _ctx.$emit('update:visible', e))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (_ctx.isSubmitingWitnesses)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
            : _createCommentVNode("", true)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.witnessesDataDefinitive, (witness, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            (index == 0 && !_ctx.isSubmitingWitnesses)
              ? (_openBlock(), _createBlock(_component_TextField, {
                  key: 0,
                  "has-error": _ctx.firstWitnessRutHasError,
                  "error-message": 'Error con el rut',
                  model: _ctx.firstWitnessRut,
                  "onUpdate:model": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.firstWitnessRut) = $event)),
                  type: "text",
                  name: "rut",
                  label: 
              index == 0 ? 'Rut del primer testigo' : 'Rut del segundo testigo'
            ,
                  "hide-details": ""
                }, null, 8, ["has-error", "model", "label"]))
              : _createCommentVNode("", true),
            (index == 1 && !_ctx.isSubmitingWitnesses)
              ? (_openBlock(), _createBlock(_component_TextField, {
                  key: 1,
                  model: _ctx.secondWitnessRut,
                  "onUpdate:model": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.secondWitnessRut) = $event)),
                  "has-error": _ctx.secondRutHasError,
                  "error-message": 'Error con el rut',
                  type: "text",
                  name: "rut",
                  label: 'Rut del segundo testigo',
                  "hide-details": ""
                }, null, 8, ["model", "has-error"]))
              : _createCommentVNode("", true),
            (
              index == 0
                ? _ctx.firstWitnessCreationAvailable
                : _ctx.secondWitnessCreationAvailable
            )
              ? (_openBlock(), _createElementBlock("section", _hoisted_5, [
                  _hoisted_6,
                  _createVNode(_component_TextField, {
                    model: witness.fullName,
                    "onUpdate:model": ($event: any) => ((witness.fullName) = $event),
                    type: "text",
                    name: "rut",
                    label: "Nombre del primer testigo",
                    "has-error": index == 0 ? _ctx.firstNameHasError : _ctx.secondNameHasError,
                    "hide-details": ""
                  }, null, 8, ["model", "onUpdate:model", "has-error"])
                ]))
              : _createCommentVNode("", true),
            (
              index == 0
                ? _ctx.witnessesDataDefinitive[0].id != undefined
                : _ctx.witnessesDataDefinitive[1].id != undefined
            )
              ? (_openBlock(), _createElementBlock("section", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("p", _hoisted_9, " Rut: " + _toDisplayString(_ctx.witnessesDataDefinitive[index].rut), 1),
                  _createElementVNode("p", _hoisted_10, " Nombre: " + _toDisplayString(_ctx.witnessesDataDefinitive[index].fullName), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]),
      footer: _withCtx(() => [
        _createElementVNode("button", {
          class: "ml-auto btn pr-8 md:pr-0",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.submitContractForm && _ctx.submitContractForm(...args))),
          disabled: _ctx.formHasError
        }, " Crear ", 8, _hoisted_11)
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}